import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { Currency } from '@shared-models';
import { DianService } from '@shared-services';
import { STRING_CONSTANTS } from '@shared-constants';

@Component({
  selector: 'app-currency',
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatButtonModule,
    TranslatePipe,
  ],
  templateUrl: './currency.component.html',
  styleUrl: './currency.component.css',
})
export class CurrencyComponent implements OnInit {
  private fb = inject(UntypedFormBuilder);
  private dialog = inject(MatDialog);
  private dianService = inject(DianService);
  private destroyRef = inject(DestroyRef);
  currencyList: Currency[] = [];
  currencyForm: UntypedFormGroup = this.fb.group({
    currency: [''],
  });

  ngOnInit(): void {
    this.dianService
      .getCurrencies()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        this.currencyList = result;
        const defaultCurrency = this.currencyList.find(
          (c) => c.code === STRING_CONSTANTS.DEFAULT_CURRENCY,
        );
        if (defaultCurrency) {
          this.currencyForm.get('currency')?.setValue(defaultCurrency.code);
        }
      });
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
